import React from 'react';
import { UserPlusIcon, FileTextIcon, CheckCircleIcon } from 'lucide-react';
import { FadeInSection } from './ui/FadeInSection';
export function HowItWorks() {
  const steps = [{
    icon: UserPlusIcon,
    title: 'Sign Up Online',
    description: 'Create your account in minutes, no sales call required.'
  }, {
    icon: FileTextIcon,
    title: 'Enter Patient & Payer Details',
    description: 'Input patient information and select the payer.'
  }, {
    icon: CheckCircleIcon,
    title: 'Review Eligibility Results',
    description: 'Get coverage details and benefits information instantly.'
  }];
  return <section className="py-20 bg-white relative overflow-hidden" data-id="element-153">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-154">
        <FadeInSection data-id="element-155">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-156">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-darkText mb-4" data-id="element-157">
              How It Works
            </h2>
            <p className="text-lg text-brand-bodyText" data-id="element-158">
              Start verifying eligibility in three simple steps.
            </p>
          </div>
        </FadeInSection>

        <div className="relative" data-id="element-159">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-gray-100 z-0" data-id="element-160"></div>

          <div className="grid md:grid-cols-3 gap-12 relative z-10" data-id="element-161">
            {steps.map((step, index) => <FadeInSection key={index} delay={index * 200} data-id="element-162">
                <div className="flex flex-col items-center text-center relative" data-id="element-163">
                  <div className="w-24 h-24 bg-white rounded-full border-4 border-brand-lightBlue flex items-center justify-center mb-6 shadow-sm relative" data-id="element-164">
                    <step.icon className="h-10 w-10 text-brand-green" data-id="element-165" />
                    <div className="absolute -top-2 -right-2 w-8 h-8 bg-brand-darkText text-white rounded-full flex items-center justify-center font-bold text-sm border-2 border-white" data-id="element-166">
                      {index + 1}
                    </div>
                  </div>
                  <h3 className="text-xl font-semibold text-brand-darkText mb-3" data-id="element-167">
                    {step.title}
                  </h3>
                  <p className="text-brand-bodyText" data-id="element-168">{step.description}</p>
                </div>
              </FadeInSection>)}
          </div>
        </div>
      </div>
    </section>;
}